export default class GobUtil {
  static getGobName(gob: number, maxGobs: number): string {
    if (!gob || !maxGobs || gob > 4 || maxGobs > 4) {
      return undefined;
    }

    if (gob === 1) {
      return 'F';
    }
    if (gob === maxGobs) {
      return 'B';
    }
    if (maxGobs === 3) {
      return 'M';
    }
    if (gob === 2) {
      return 'FM';
    }
    return 'BM';
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/services/utility/gob.utility.ts